import { render } from "./Vnud-Dashboard.vue?vue&type=template&id=0363a18c&scoped=true"
import script from "./Vnud-Dashboard.vue?vue&type=script&lang=js"
export * from "./Vnud-Dashboard.vue?vue&type=script&lang=js"

import "./Vnud-Dashboard.vue?vue&type=style&index=0&id=0363a18c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ricar\\OneDrive\\Ambiente de Trabalho\\Projetos\\WIP\\Reorganiza\\Leadcenter\\Dashboard\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0363a18c"]])

export default __exports__